import { all, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { setSections, setSelectedSection } from "../slices/webbuilderSlice";
import { Page, Section } from "@/types/models/page";
import { fetchPageSuccess } from "../slices/page.slice";

// This saga listens for when a page is successfully fetched and then populates the web builder state.
function* handleFetchPageSuccess(
  action: PayloadAction<{ page: Page }>,
): Generator<any, void, any> {
  try {
    const page = action.payload.page;
    console.log("🔄 WebBuilder saga handling fetchPageSuccess:", {
      pageId: page.id,
      pageName: page.name,
      sectionsCount: page.sections?.length || 0,
    });

    if (page && page.sections) {
      const sections: Section[] = page.sections;
      console.log("📥 Setting sections in Redux store:", {
        sectionsCount: sections.length,
        sectionIdentifiers: sections.map((s) => s.section_identifier),
        sectionKeys: sections.map((s) => Object.keys(s || {})),
        componentDataKeys: sections.map((s) =>
          Object.keys(s.component_data || {}),
        ),
        inputsKeys: sections.map((s: any) => Object.keys(s.inputs || {})),
      });

      yield put(setSections(sections));

      // Set the first section as selected by default
      if (sections.length > 0) {
        console.log("🎯 Setting first section as selected:", sections[0].id);
        yield put(setSelectedSection(sections[0]));
      }
    } else {
      
    }
  } catch (error) {
    console.error("Failed to handle fetchPageSuccess in webBuilderSaga", error);
  }
}

// Watcher saga
function* webBuilderSaga() {
  yield takeLatest(fetchPageSuccess.type, handleFetchPageSuccess);
}

export default function* rootWebBuilderSaga() {
  yield all([webBuilderSaga()]);
}
